import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics';

import { firedAt, type CardErrorType } from '../../analytics';

import { CardError } from './CardError';

/**
 * Renders the error state and fires `ui.profilecard.rendered.error` with
 * `errorType` and `hasRetry`. Today the card never offers a retry affordance,
 * so `hasRetry` is always `false` - kept as an explicit attribute (rather
 * than omitted) so the SLO dashboards see a consistent shape that can be
 * partitioned later if a retry UI is added.
 */
export function CardErrorState({
	testId,
	errorType,
}: {
	testId: string;
	errorType: CardErrorType;
}): React.JSX.Element {
	const { fireEvent } = useAnalyticsEvents();
	useEffect(() => {
		fireEvent('ui.profilecard.rendered.error', {
			firedAt: firedAt(),
			errorType,
			hasRetry: false,
		});
	}, [fireEvent, errorType]);
	return <CardError testId={testId} />;
}
